import { Boundaries } from "@planzone/core";
import { events } from "@planzone/events";
import { createStateReducer } from "../../utils/createStateReducer";
import { setRequestStateToPending } from "../../utils/setRequestStateToPending";
import { setRequestStateToSuccess } from "../../utils/setRequestStateToSuccess";
import { setRequestStateToFailure } from "../../utils/setRequestStateToFailure";
import { resetState } from "../../utils/resetState";
import { State, Selector } from "./types";

const initialState: State = {
  request: {
    isPending: false,
    isSuccessful: false,
    isFailure: false,
  },
  uuid: null,
};

function handleRequest(
  state: State,
  { group }: Boundaries["addEveryoneToResourceGroup"]["request"],
): State {
  return { request: setRequestStateToPending(), uuid: group.uuid };
}

function handleSuccess(
  state: State,
  { group }: Boundaries["addEveryoneToResourceGroup"]["success"],
): State {
  return { request: setRequestStateToSuccess(), uuid: group.uuid };
}

function handleFailure(
  state: State,
  { group }: Boundaries["addEveryoneToResourceGroup"]["failure"],
): State {
  return { request: setRequestStateToFailure(), uuid: group.uuid };
}

const reduceState = resetState(
  initialState,
  createStateReducer(initialState, {
    [events.addEveryoneToResourceGroupRequested]: handleRequest,
    [events.addEveryoneToResourceGroupSucceeded]: handleSuccess,
    [events.addEveryoneToResourceGroupFailed]: handleFailure,
  }),
  [events.changePlanzoneSucceeded],
);

function createSelector(getState: () => State): Selector {
  return {
    isAddEveryoneToResourceGroupRequestPending({ uuid }) {
      return getState().uuid === uuid && getState().request.isPending;
    },
    isAddEveryoneToResourceGroupRequestSuccess({ uuid }) {
      return getState().uuid === uuid && getState().request.isSuccessful;
    },
    isAddEveryoneToResourceGroupRequestFailure({ uuid }) {
      return getState().uuid === uuid && getState().request.isFailure;
    },
  };
}

export type { State, Selector };

export { reduceState, initialState, createSelector };
